import { useEffect, useRef, useState } from "react";
import { Group, Rect, Text, Transformer } from "react-konva";

const Track = ({
  trackId,
  visibleTrackId,
  coords,
  stageScale = 1,
  rectColor = "blue",
  tempRectColor,
  textColor = "white",
  idVisible,
  trackResizable,
  onTrackClick,
  onTrackRightClick,
  onResizeTrack,
  isTemp = false,
}) => {
  const shapeRef = useRef();
  const trRef = useRef();

  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    if (isSelected) {
      // we need to attach transformer manually
      if (trRef.current) {
        trRef.current.nodes([shapeRef.current]);
        trRef.current.getLayer().batchDraw();
      }
    }
  }, [isSelected]);

  const onClick = (trackId) => {
    if (typeof onTrackClick === "function") {
      onTrackClick(trackId);
    }
    // to show transformer when it's selected
    if (trackResizable) setIsSelected(!isSelected);
  };

  const onResize = (payload) => {
    if (typeof onResizeTrack === "function") {
      onResizeTrack(trackId, payload);
    }
  };

  return (
    <Group name="track" onClick={() => onClick(trackId)} onContextMenu={(e) => {
        e.evt.preventDefault();
        if (typeof onTrackRightClick === "function") onTrackRightClick(trackId);
      }}>
      <Rect
        ref={shapeRef}
        name={isTemp ? "tempRect" : "rect"}
        trackId={trackId}
        x={coords[0]}
        y={coords[1]}
        width={coords[2] - coords[0]}
        height={coords[3] - coords[1]}
        stroke={isTemp && tempRectColor ? tempRectColor : rectColor}
        strokeWidth={1 / stageScale}
        draggable={trackResizable ? true : false}
        onDragEnd={(e) => {
          const node = shapeRef.current;
          if (!node) return;
          onResize({
            x: node.x(),
            y: node.y(),
            width: node.width(),
            height: node.height(),
            type: "move",
          });
        }}
        onTransformEnd={(e) => {
          const node = shapeRef.current;
          if (!node) return;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);
          onResize({
            x: node.x(),
            y: node.y(),
            width: Math.max(1, node.width() * scaleX),
            height: Math.max(1, node.height() * scaleY),
            type: "resize",
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          rotateEnabled={false}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            // if (newBox.width < 5 || newBox.height < 5) {
            //   return oldBox;
            // }
            return newBox;
          }}
        />
      )}
      {idVisible && (
        <>
          <Text
            name="text"
            x={coords[0]}
            y={coords[1]}
            text={trackId}
            fill={textColor}
            fontSize={12 / stageScale}
          />
          {visibleTrackId && (
            <Text
              name="text"
              x={coords[0]}
              y={coords[3]}
              text={visibleTrackId}
              fill={textColor}
              fontSize={12 / stageScale}
            />
          )}
        </>
      )}
    </Group>
  );
};

export default Track;
